var map = {
	"./Game/IndexComp.vue": [
		1219,
		219
	],
	"./Game2/IndexComp.vue": [
		9677,
		677
	],
	"./Home/IndexComp.vue": [
		8959,
		959
	],
	"./Login/IndexComp.vue": [
		9619,
		619
	],
	"./Profile/IndexComp.vue": [
		20,
		20
	],
	"./Ranking/IndexComp.vue": [
		2969,
		969
	],
	"./RuletteGame/IndexComp.vue": [
		9253,
		192,
		253
	],
	"./UnoGame/IndexComp.vue": [
		1504,
		192,
		504
	],
	"./Video/IndexComp.vue": [
		1387,
		387
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4141;
module.exports = webpackAsyncContext;